import { render, staticRenderFns } from "./electricity-collect.vue?vue&type=template&id=6e959ac7&scoped=true"
import script from "./electricity-collect.vue?vue&type=script&lang=js"
export * from "./electricity-collect.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/public-style.css?vue&type=style&index=0&id=6e959ac7&prod&scoped=true&lang=css&external"
import style1 from "./electricity-collect.vue?vue&type=style&index=1&id=6e959ac7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e959ac7",
  null
  
)

export default component.exports